import { autoinject } from "aurelia-framework";
import { GeneralLookupsApi, LookupFilter } from 'api/general-lookups';
import { City } from 'model/business-keywords';
import { UserContact } from 'model/business-types';
import { CitiesClient, SystemUsersClient } from "api/swagger/ApiClient";
import { BusinessKeywordsMapping } from "api/client/mapping/business-keywords-mapping";
import { BusinessTypesMapping } from "api/client/mapping/business-types-mapping";

@autoinject
export class GeneralLookupsClientApi implements GeneralLookupsApi {
  constructor(private systemUsersClient: SystemUsersClient, private citiesClient: CitiesClient, private businessTypesMapping: BusinessTypesMapping, private businessKeywordsMapping: BusinessKeywordsMapping) {
  }

  async lookupUsers(filter: LookupFilter): Promise<UserContact[]> {
    return (await this.systemUsersClient.lookupADUsers(filter.text)).map(x => this.businessTypesMapping.mapADUserToUserContact(x));
  }

  async lookupCities(filter: LookupFilter): Promise<City[]> {
    return (await this.citiesClient.lookupActiveCities(filter.text)).map(x => this.businessKeywordsMapping.mapToCity(x));
  }
}
